var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _circle, _path4, _circle2, _path5, _circle3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#1a81c4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -0.5,
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192,292.51A100.51,100.51,0,1,1,292.51,192,100.62,100.62,0,0,1,192,292.51Zm0-193A92.51,92.51,0,1,0,284.51,192,92.62,92.62,0,0,0,192,99.5Z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.53,
    y: 190.4,
    width: 190.94,
    height: 8,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.79,
    y: 140.84,
    width: 168.42,
    height: 8,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 239.95,
    width: 157.6,
    height: 8,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.77,292.52c-10.7,0-20.37-11-27.23-31-6.41-18.64-9.94-43.34-9.94-69.55s3.53-50.91,9.94-69.55c6.86-20,16.53-31,27.23-31s20.38,11,27.24,31c6.41,18.64,9.93,43.34,9.93,69.55s-3.52,50.91-9.93,69.55C212.15,281.52,202.47,292.52,191.77,292.52Zm0-193c-13.79,0-29.17,38-29.17,92.52s15.38,92.52,29.17,92.52,29.17-38,29.17-92.52S205.57,99.48,191.77,99.48Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.77,292.52c-40.46,0-73.38-45.09-73.38-100.52S151.31,91.48,191.77,91.48,265.16,136.57,265.16,192,232.24,292.52,191.77,292.52Zm0-193c-36.05,0-65.38,41.5-65.38,92.52s29.33,92.52,65.38,92.52S257.16,243,257.16,192,227.82,99.48,191.77,99.48Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.22,
    cy: 142.96,
    r: 17.27,
    fill: "#1a81c4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.22,164.24A21.28,21.28,0,1,1,187.49,143,21.3,21.3,0,0,1,166.22,164.24Zm0-34.55A13.28,13.28,0,1,0,179.49,143,13.29,13.29,0,0,0,166.22,129.69Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.69,
    cy: 240.01,
    r: 17.27,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.69,261.28A21.27,21.27,0,1,1,242,240,21.29,21.29,0,0,1,220.69,261.28Zm0-34.54A13.27,13.27,0,1,0,234,240,13.29,13.29,0,0,0,220.69,226.74Z",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.06,
    cy: 192.01,
    r: 17.27,
    fill: "#1a81c4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.06,213.28A21.27,21.27,0,1,1,146.33,192,21.29,21.29,0,0,1,125.06,213.28Zm0-34.54A13.27,13.27,0,1,0,138.33,192,13.28,13.28,0,0,0,125.06,178.74Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.e5e3d0c2edb0781d78e55c2524ba6871.svg";
export { ForwardRef as ReactComponent };